import { supabase } from './supabase'
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://yviqlmtoftjjzgrrcowd.supabase.co'
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || ''

function getStorageClient() {
  // Always use the anonymous client to bypass the JWT sub/owner constraint for drivers.
  // Supabase Storage requires the JWT `sub` to exist in `auth.users`, but drivers are not in that table.
  // This requires the `refuel-photos` bucket to have a public INSERT policy.
  return createClient(supabaseUrl, supabaseAnonKey, {
    auth: { persistSession: false }
  })
}

export async function uploadRefuelPhoto(file: File, path: string): Promise<string | null> {
  try {
    console.log(`Uploading file to refuel-photos bucket with path: ${path}`)

    const client = getStorageClient()
    const { data, error } = await client.storage
      .from('refuel-photos')
      .upload(path, file)

    if (error) {
      console.error('Failed to upload refuel photo:', error)
      // Log error details  
      console.error('Error details:', error)
      return null
    }

    // Get public URL
    const publicUrlResult = client.storage.from('refuel-photos').getPublicUrl(path)
    console.log(`Photo uploaded successfully: ${publicUrlResult.data.publicUrl}`)
    return publicUrlResult.data.publicUrl || null

  } catch (err) {
    console.error('Exception during photo upload:', err)
    throw err
  }
}

export async function uploadVoucherPhoto(file: File, path: string): Promise<string | null> {
  try {
    console.log(`Uploading voucher file to refuel-photos bucket with path: ${path}`)

    const client = getStorageClient()
    
    console.log(`Uploading voucher file size: ${file.size} bytes, type: ${file.type}`);
    if (!file || file.size === 0) {
      throw new Error('Voucher photo file is empty or corrupted (0 bytes).');
    }

    const { data, error } = await client.storage
      .from('refuel-photos')
      .upload(path, file)

    if (error) {
      console.error('Failed to upload voucher photo:', error)
      throw new Error(`Supabase upload error: ${error.message} (Code: ${error.name})`);
    }

    // Get public URL
    const publicUrlResult = client.storage.from('refuel-photos').getPublicUrl(path)
    console.log(`Voucher photo uploaded successfully: ${publicUrlResult.data.publicUrl}`)
    return publicUrlResult.data.publicUrl || null

  } catch (err) {
    console.error('Exception during voucher photo upload:', err)
    throw err
  }
}

export async function uploadSlipPhoto(file: File, path: string): Promise<string | null> {
  try {
    console.log(`Uploading slip file to refuel-photos bucket with path: ${path}`)

    const client = getStorageClient()
    
    console.log(`Uploading slip file size: ${file.size} bytes, type: ${file.type}`);
    if (!file || file.size === 0) {
      throw new Error('Slip photo file is empty or corrupted (0 bytes).');
    }

    const { data, error } = await client.storage
      .from('refuel-photos')
      .upload(path, file)

    if (error) {
      console.error('Failed to upload slip photo:', error)
      throw new Error(`Supabase upload error: ${error.message} (Code: ${error.name})`);
    }

    // Get public URL
    const publicUrlResult = client.storage.from('refuel-photos').getPublicUrl(path)
    console.log(`Slip photo uploaded successfully: ${publicUrlResult.data.publicUrl}`)
    return publicUrlResult.data.publicUrl || null

  } catch (err) {
    console.error('Exception during slip photo upload:', err)
    throw err
  }
}
